import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function StudentLogin() {
  const { studentLogin } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = React.useState("");
  const [pin, setPin] = React.useState("");
  const [err, setErr] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await studentLogin(username.trim(), pin.trim());
      nav("/play", { replace: true });
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="sw-card p-8">
        <h1 className="display text-3xl font-bold">Hi, friend</h1>
        <p className="text-[var(--sw-ink-soft)] mt-1">Type your username and your 4-digit PIN.</p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-base font-semibold">Username</span>
            <input
              data-testid={TID.studentLoginUsername}
              required
              autoCapitalize="off"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 w-full h-14 px-4 rounded-2xl border border-[var(--sw-line)] bg-white text-xl"
            />
          </label>
          <label className="block">
            <span className="text-base font-semibold">PIN</span>
            <input
              data-testid={TID.studentLoginPin}
              required
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={8}
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/[^0-9]/g, ""))}
              className="mt-1 w-full h-14 px-4 rounded-2xl border border-[var(--sw-line)] bg-white text-2xl tracking-[0.5em] text-center"
            />
          </label>
          {err && <div data-testid={TID.studentLoginError} className="text-sm text-[var(--gusty-text)] bg-[var(--gusty-bg)] border border-[var(--gusty-border)] rounded-xl p-3">{err}</div>}
          <button data-testid={TID.studentLoginSubmit} disabled={busy} className="sw-pill w-full h-14 justify-center bg-[var(--sw-primary)] text-white border-[var(--sw-primary)] text-lg">
            {busy ? "Opening…" : "Open my boxes"}
          </button>
        </form>
        <div className="mt-6 text-sm text-[var(--sw-ink-soft)]">
          Therapist? <Link to="/login" className="text-[var(--sw-primary)] font-semibold underline">Sign in here</Link>
        </div>
        <div className="mt-6 p-3 rounded-xl bg-[var(--sw-bg-soft)] border border-[var(--sw-line)] text-xs text-[var(--sw-ink-soft)]">
          <div className="font-semibold text-[var(--sw-ink)]">Demo student</div>
          <div>Username: ash · PIN: 1234</div>
        </div>
      </div>
    </div>
  );
}
